var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9064c7cbbaf4e1e549a3acdc3a4469cde811460a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["widget@swipelux-mh"]={id:"9064c7cbbaf4e1e549a3acdc3a4469cde811460a"};
      